import types from "./types";

const initialState = {
    loading: false,
    loaded: false,
    selectedNonSode: null,
    list: {
        items: {},
        fields: null,
        pagination: {
            count: 0,
            actualPage: 1,
            previous: null,
            next: null,
            pages: 0
        }
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.DELETE_NON_SODE_BYID:
        case types.PARTIAL_UPDATE_NON_SODE:
        case types.UPDATE_NON_SODE:
        case types.GET_NON_SODE_BYID:
        case types.CREATE_NON_SODE:
        case types.LIST_NON_SODES: {
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }

        case types.DELETE_NON_SODE_BYID_FAIL:
        case types.PARTIAL_UPDATE_NON_SODE_FAIL:
        case types.UPDATE_NON_SODE_FAIL:
        case types.GET_NON_SODE_BYID_FAIL:
        case types.CREATE_NON_SODE_FAIL:
        case types.LIST_NON_SODES_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false
            };
        }

        case types.DELETE_NON_SODE_BYID_SUCCESS: {
            return {
                ...state,

                loading: false,
                loaded: true
            };
        }
        case types.PARTIAL_UPDATE_NON_SODE_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        case types.UPDATE_NON_SODE_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        case types.GET_NON_SODE_BYID_SUCCESS: {
            return {
                ...state,
                selectedNonSode: action.payload,
                loading: false,
                loaded: true
            };
        }
        case types.CREATE_NON_SODE_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        case types.LIST_NON_SODES_SUCCESS: {
            const items = action.payload.results.reduce((entities, item, i) => ({ ...entities, [i]: item }), {});
            return {
                ...state,
                loading: false,
                loaded: true,
                list: {
                    items,
                    fields: action.payload.form_filter,
                    pagination: {
                        count: action.payload.count,
                        actualPage: action.payload.actual,
                        pages: action.payload.pages,
                        next: action.payload.next,
                        previous: action.payload.previous
                    }
                }
            };
        }

        default: {
            return state;
        }
    }
};
